import moment from 'moment-timezone';

export class EnterpriseDashboardBudgetLocationMonthlyChartData {
	public date: Date;
	public nextBudgetCost: number;
	public actualCost: number;

	constructor(enterpriseDashboardBudgetLocationMonthlyChartData?: EnterpriseDashboardBudgetLocationMonthlyChartData) {
		Object.assign(this, enterpriseDashboardBudgetLocationMonthlyChartData);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY 00:00:00 a')) : this.date;
	}
}
